import { render, staticRenderFns } from "./UserDetailList.vue?vue&type=template&id=4c673688&scoped=true&"
import script from "./UserDetailList.vue?vue&type=script&lang=js&"
export * from "./UserDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c673688",
  null
  
)

export default component.exports